import { getCheapestProduct } from 'pages/calculation/helpers/get-cheapest-product';
import { getFormattedComplimentaryGroups } from 'pages/calculation/helpers/get-formatted-complimentary-groups';
import { getProductsWithRequiredData } from 'pages/common/helpers/get-products-with-required-data';
import { TComplimentaryGroup, TComplimentaryProductInfo, TCalculateData } from '../store/dimensions';

type TParams = {
  complimentaryProductInfo: TComplimentaryProductInfo[] | [];
  complimentaryGroups: TComplimentaryGroup[];
};

const buildCheckedProducts = ({ complimentaryProductInfo, complimentaryGroups }: TParams) => {
  // Товары из complimentaryProductInfo
  const complimentaryProducts = complimentaryProductInfo.map(item => ({
    id: item.productId,
    isChecked: true,
  }));

  // Самые дешевые товары из каждой группы
  const complimentaryGroupProducts = complimentaryGroups.map(group => ({
    id: getCheapestProduct(group.products).productId,
    isChecked: group.requiredToBuy ?? true,
  }));

  return [...complimentaryProducts, ...complimentaryGroupProducts];
};

export const getFormattedCalculateParams = (calculateParams: TCalculateData) => {
  const complimentaryGroups = getFormattedComplimentaryGroups(calculateParams.complimentaryGroups);
  const complimentaryProductInfo = getProductsWithRequiredData(calculateParams.complimentaryProductInfo);
  const totalComplimentaryProductCount = complimentaryProductInfo.length + complimentaryGroups.length;

  return {
    ...calculateParams,
    complimentaryProductInfo,
    complimentaryGroups,
    checkedProducts: totalComplimentaryProductCount
      ? buildCheckedProducts({ complimentaryProductInfo, complimentaryGroups })
      : [],
  };
};
